// @ts-nocheck
import { Icon } from "@shared/antd/icon";
import * as React from "react";
import { ExtTaskData } from "../../../../cuba/entities/base/tsadv_ExtTaskData";
import { DicHrRole } from "../../../../cuba/entities/base/tsadv$DicHrRole";
import { Msg } from "@cuba-platform/react";
import { TsadvUser } from "../../../../cuba/entities/base/tsadv$UserExt";
import Candidate from "../component/Candidate";
import { FormattedMessage, IntlShape } from "react-intl";
import { DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS, formatDate } from "../../../util/Date/Date";
import { ColumnProps } from "antd/lib/table";
import { CommentBlock, HrRoleBlock, OutcomeBlock } from "../../../common/table/ui/approvers-table-blocks";

export const getTaskTableColumns = (intl: IntlShape, selectedElement: any, setSelectedElement: any) => [
  {
    title: intl.formatMessage({ id: "bproc.startBproc.modal.role" }),
    dataIndex: "hrRole",
    key: "hrRole",
    ellipsis: true,
    render: (_, record) =>
      record.hrRole ? (record.hrRole as DicHrRole).langValue : "",
  },
  {
    title: intl.formatMessage({ id: "bproc.startBproc.modal.user" }),
    dataIndex: "assigneeOrCandidates",
    key: "assigneeOrCandidates",
    ellipsis: true,
    render: (_, record) => (
      <Candidate candidates={record.assigneeOrCandidates as TsadvUser[] | null} />
    ),
  },
  {
    title: <FormattedMessage id="createDate" />,
    dataIndex: "createTime",
    key: "createTime",
    ellipsis: true,
    render: (_, record) =>
      formatDate(record.createTime!, DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS),
  },
  {
    title: <FormattedMessage id="endDate" />,
    dataIndex: "endTime",
    key: "endTime",
    ellipsis: true,
    render: (_, record) =>
      formatDate(record.endTime, DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS),
  },
  {
    title: <FormattedMessage id="bproc.startBproc.modal.outcome" />,
    dataIndex: "outcome",
    key: "outcome",
    ellipsis: true,
    render: (_, record) =>
      record.outcome ? (
        intl.formatMessage({ id: `result.${record.outcome}` })
      ) : (
        ""
      ),
  },
  {
    title: <FormattedMessage id="bproc.startBproc.modal.comments" />,
    dataIndex: "comment",
    key: "comment",
    ellipsis: true,
    render: (_, record) => record.comment,
  },
];


export const getTaskColumns = (intl: any, requestStatusColor: any, onExpandChild: any): ColumnProps<ExtTaskData>[] => [
  {
    title: <Msg entityName={ExtTaskData.NAME} propertyName="hrRole" />,
    dataIndex: "hrRole",
    key: "hrRole",
    ellipsis: true,
    render: (_, record) => {
      const colorClass = requestStatusColor[record.outcome] || "gray-300";
      const roleValue = (record.hrRole as DicHrRole)?.langValue || "";

      return (
        <div className="flex items-start" title={roleValue}>
          <div className={`w-1 absolute h-full left-0 top-0 rounded-sm mr-2 bg-${colorClass}`} />
          <div className="break-words">{roleValue}</div>
        </div>
      );
    },
  },
  {
    title: intl.formatMessage({ id: "bproc.startBproc.modal.user" }),
    dataIndex: "assigneeOrCandidates",
    key: "assigneeOrCandidates",
    ellipsis: true,
    render: (_, record) =>
      <Candidate candidates={record.assigneeOrCandidates as TsadvUser[] || []} />,
  },
  {
    title: <FormattedMessage id="createDate" />,
    dataIndex: "createTime",
    key: "createTime",
    ellipsis: true,
    render: (_, record) =>
      <div className="break-words">
        {formatDate(record.createTime!, DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS)}
      </div>,
  },
  {
    title: <FormattedMessage id="endDate" />,
    dataIndex: "endTime",
    key: "endTime",
    ellipsis: true,
    render: (_, record) =>
      <div className="break-words">
        {formatDate(record.endTime!, DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS)}
      </div>,
  },
  {
    title: <Msg entityName={ExtTaskData.NAME} propertyName="outcome" />,
    dataIndex: "outcome",
    key: "outcome",
    ellipsis: true,
    render: (_, record) => {
      const outcome = record.outcome;
      return outcome ? (
        <div className="break-words">
          {intl.formatMessage({ id: "result." + outcome })}
        </div>
      ) : "";
    },
  },
  {
    title: <Msg entityName={ExtTaskData.NAME} propertyName="comment" />,
    dataIndex: "comment",
    key: "comment",
    ellipsis: true,
    render: (_, record) =>
      record.comment ? <div className="break-words">{record.comment}</div> : null,
  },
  {
    title: intl.formatMessage({ id: "Mobile" }),
    dataIndex: "mobile",
    key: "mobile",
    className: "mobile-coll",
    render: getMobileRender(onExpandChild, requestStatusColor, intl),
  },
];

const getMobileRender = (
  onExpandChild: (key: string) => void,
  requestStatusColor: any,
  intl,
) => (_, record: any) => {
  const startDate = record?.createTime
    ? formatDate(record.createTime, DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS)
    : null;
  const endDate = record?.endTime
    ? formatDate(record.endTime, DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS)
    : null;

  const colorClass = requestStatusColor[record.outcome] || "gray-300";
  const hasChildren = record.childs?.length > 0;
  const isExpanded = record.isOpened;

  return (
    <div className="grid grid-cols-1 gap-4 w-full">
      <div
        className="bg-white rounded-xl shadow-md p-4 flex flex-col gap-2 border border-gray-100 relative text-gray-600 text-sm">
        <HrRoleBlock
          colorClass={colorClass}
          candidates={record.assigneeOrCandidates as TsadvUser[]}
          hrRole={record.hrRole as DicHrRole}
        />

        {(startDate || endDate) && (
          <div className="text-xs">
            {startDate}
            {endDate ? ` - ${endDate}` : null}
          </div>
        )}

        <OutcomeBlock colorClass={colorClass} intl={intl} outcome={record.outcome} />
        <CommentBlock comment={record.comment} />
        {hasChildren && (
          <div className={"ml-auto w-8 h-6"}>
            <button
              onClick={() => onExpandChild(record.key)}
              className={`w-full h-full flex items-center justify-center border border-gray-400 rounded text-xs font-bold text-gray-700 ${hasChildren ? "block" : "hidden"}`}
            >
              <Icon type={isExpanded ? "caret-up" : "caret-down"} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
